
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Autism(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Autism"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Autism is a <b>neurodevelopmental disorder characterized
                                        by difficulties with social interaction and
                                        communication,</b> and by restricted and repetitive behavior.
                                    Parents often notice signs during the first three years of
                                    their child's life.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Autism/1.png")} alt="Autism" />
                                    </div>
                                </div>
                             <br></br>
                                <p>
                                    <b>3 Main Symptoms of Autism</b>
                                </p>
                                <p>Delayed milestones.</p>
                                <p>A socially awkward child.</p>
                                <p>The child who has trouble with verbal and nonverbal communication.</p>
                               
                                
                                <a className="links" href="https://en.wikipedia.org/wiki/Autism">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Autism;